import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check, X } from 'lucide-react';
const names = ['María', 'Lucía', 'Florencia', 'Carolina', 'Sofía', 'Camila', 'Valeria', 'Agustina', 'Daniela', 'Romina', 'Julieta', 'Belén', 'Micaela', 'Antonella', 'Paula', 'Mariana', 'Andrea', 'Gisela', 'Verónica', 'Natalia'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Tucumán', 'Salta', 'Neuquén', 'Bariloche', 'Bahía Blanca', 'Santa Fe', 'San Juan', 'Resistencia', 'Posadas', 'Paraná', 'Río Cuarto'];
const products = [{
  name: 'Sistema Integral de Intervención en Tartamudez',
  image: 'https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?w=100&h=100&fit=crop'
}, {
  name: 'Kit Clínico Cognitivo',
  image: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=100&h=100&fit=crop'
}, {
  name: 'Mega Pack Terapéutico',
  image: 'https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=100&h=100&fit=crop'
}, {
  name: 'Mega Pack Intervención en Dislexia',
  image: 'https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?w=100&h=100&fit=crop'
}, {
  name: 'Mega Pack Intervención en TDAH',
  image: 'https://images.unsplash.com/photo-1497633762265-9d179a990aa6?w=100&h=100&fit=crop'
}];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentData, setCurrentData] = useState({
    name: '',
    city: '',
    product: products[0],
    minutes: 0
  });
  const generateRandomData = () => {
    const randomName = names[Math.floor(Math.random() * names.length)];
    const randomCity = cities[Math.floor(Math.random() * cities.length)];
    const randomProduct = products[Math.floor(Math.random() * products.length)];
    const randomMinutes = Math.floor(Math.random() * 59) + 1;
    setCurrentData({
      name: randomName,
      city: randomCity,
      product: randomProduct,
      minutes: randomMinutes
    });
  };
  useEffect(() => {
    // Initial delay of 5 seconds
    const initialTimer = setTimeout(() => {
      generateRandomData();
      setIsVisible(true);
    }, 5000);
    // Interval for subsequent popups every 30 seconds
    const intervalTimer = setInterval(() => {
      generateRandomData();
      setIsVisible(true);
    }, 30000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(intervalTimer);
    };
  }, []);
  useEffect(() => {
    if (isVisible) {
      // Auto dismiss after 6 seconds
      const dismissTimer = setTimeout(() => {
        setIsVisible(false);
      }, 6000);
      return () => clearTimeout(dismissTimer);
    }
  }, [isVisible]);
  return <AnimatePresence data-id="element-64">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 md:bottom-8 md:left-8 z-50 max-w-[320px] bg-white rounded-xl shadow-2xl border border-gray-100 p-4 flex gap-4 pr-10" data-id="element-65">
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 transition-colors" data-id="element-66">
            <X className="w-4 h-4" data-id="element-67" />
          </button>

          <div className="flex-shrink-0 relative" data-id="element-68">
            <img src={currentData.product.image} alt={currentData.product.name} className="w-12 h-12 rounded-lg object-cover" data-id="element-69" />
            <div className="absolute -bottom-1 -right-1 bg-green-500 rounded-full p-0.5 border-2 border-white" data-id="element-70">
              <Check className="w-3 h-3 text-white" data-id="element-71" />
            </div>
          </div>

          <div className="flex flex-col justify-center" data-id="element-72">
            <p className="text-sm text-gray-800 leading-tight mb-1" data-id="element-73">
              <span className="font-bold" data-id="element-74">{currentData.name}</span> de{' '}
              {currentData.city} acaba de comprar
            </p>
            <p className="text-xs font-semibold text-brand-primary leading-tight mb-1" data-id="element-75">
              {currentData.product.name}
            </p>
            <p className="text-[10px] text-gray-500" data-id="element-76">
              hace {currentData.minutes}{' '}
              {currentData.minutes === 1 ? 'minuto' : 'minutos'}
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}